import script from "./uploadFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadFile.vue?vue&type=script&lang=ts&setup=true"

import "./uploadFile.vue?vue&type=style&index=0&id=792c9e31&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792c9e31"]])

export default __exports__